import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import SelectCustom from "./elements/SelectCustom"

function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
    return (
        <label
            for={lableFor}
            className={`ns-act-btn ns-filters ns-font-5 ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center ${className} pd-width-50 pd-badge-black pd-border-r-0`}
        >
            <Icon name="filter-alt" className="pd-icon ns-mx-4" />
            <span>Filter</span>
            {/* {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )} */}
        </label>
    )
}

export default function Toolbar({ lableFor }) {
    const { loading, query, response, pageType } = useAppState()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <div
            class="ns-header-controls ns-d-flex ns-flex-column ns-flex-md-row ns-d-none ns-d-md-flex  ns-flex-wrap align-center ns-justify-content-between ns-justify-content-md-end ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {/* {!loading && (
                <span
                    class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center ns-color-black"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </span>
            )} */}
            <div class="ns-d-flex ns-flex-nowrap ns-justify-content-between ns-d-md-block ns-w-100 pd-filter-container">
                <ToggleMobileSidebarButton
                    lableFor={lableFor}
                    selectedFiltersCount={selectedFiltersCount}
                />
                <SelectCustom
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu ns-w-100 ns-h-100 pd-selection-dropdown-menu"
                    classNameContainer="pd-width-50 pd-width-l-100 pd-selection-label"
                    options={options}
                    labelTitle="Sort By:"
                />
            </div>
        </div>
    )
}
